module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader'), _vm._v(" \n  Logging out...\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a579b9d0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/Logout.vue
// module id = 723
// module chunks = 1